module.exports = __webpack_public_path__ + "img/high_well-being.a31947ee.png";